/**
 * Gifts the family has asked the site to name, in their own words.
 *
 * James sent the first one on 2026-09-14: KC and Joanna Quintana gave $5,000
 * toward the food for the celebration of life, and he asked for it front and
 * centre. Only what the family supplied goes in this list - the names, the
 * amount and what the gift is for. Nothing about the givers is invented; see
 * docs/COPY.md.
 *
 * Another gift is one more entry here and it appears everywhere <ThankYou />
 * is rendered: the home page under the hero, the event page and the donate
 * page. An empty list renders nothing.
 */
const GIFTS = [
  {
    names: 'KC and Joanna Quintana',
    amount: '$5,000',
    toward: "toward the food for Brandon's celebration of life",
  },
];

/**
 * Full-bleed gratitude band: yellow eyebrow, the givers' names in the display
 * face, the amount in the yellow reserved for numbers. No donate button lives
 * here on purpose - a thank you that ends in an ask is not a thank you.
 */
export function ThankYou({ className }: { className?: string }) {
  if (GIFTS.length === 0) return null;
  return (
    <section
      aria-label="Thank you"
      className={`bg-hex border-y border-white/10 bg-night-900 ${className ?? ''}`}
    >
      <div className="mx-auto max-w-6xl px-4 py-16 sm:py-20">
        <p className="text-meta text-lg">Thank you</p>
        <ul className="mt-6 flex flex-col gap-10">
          {GIFTS.map((gift) => (
            <li key={gift.names}>
              <h2 className="text-4xl sm:text-5xl">{gift.names}</h2>
              <p className="mt-3 max-w-3xl text-xl text-ink-200 sm:text-2xl">
                <span className="text-yellow-500">{gift.amount}</span> {gift.toward}.
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
